import React, { useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Layout, Menu } from "antd";
import {useAuth} from "../../../hooks"
import {checkUserLogin} from "../../../providers/AuthProvider"
// import {useAuth} from "../../../hooks/useAuth"
import {
  UserOutlined,
  HomeOutlined,
  SettingOutlined,
  EuroCircleOutlined,
  DatabaseOutlined,
  ScheduleOutlined,
  ContactsOutlined,
  GlobalOutlined,
  BankOutlined,
  ShareAltOutlined,
  CalculatorOutlined,
  CarOutlined,
  MenuOutlined,
  ClockCircleOutlined,
  UploadOutlined,
  MobileOutlined,
  HeatMapOutlined,
  HistoryOutlined
} from "@ant-design/icons";
import "./MenuSider.scss";

import Collapse from "react-bootstrap/Collapse";

function onClickMenu(setUser,setRol){
  try {
   //console.log('he entrado jeje')
    checkUserLogin(setUser,setRol);
  } catch (e) {
   //console.log(e);
  }
}

function MenuSider(props) {
  const{setUser,rol,setRol}=useAuth();
  const { menuCollapsed, location, politicas } = props;

  const { Sider } = Layout;
  try {
    const numero_politicas = politicas.delegationEvidence.policySets.length;
    var resource = [];
    var devices = false;
    var simulator = false;
    for (let step = 0; step < numero_politicas; step++) {
      var resource_type =
        politicas.delegationEvidence.policySets[step].policies[0].target
          .resource.type;
      var actions =
        politicas.delegationEvidence.policySets[step].policies[0].target
          .actions;

      var rules =
        politicas.delegationEvidence.policySets[step].policies[0].rules;
      //console.log(resource_type);
     //console.log(actions.find((element) => element == "GET"));
      if (resource_type === "DV4CULSIMULATION") {
        simulator = true;
        //console.log("1");
        if (
          (actions.find((element) => element == "GET") != null &&
            actions.find((element) => element == "POST") != null) ||
          actions.find((element) => element == "*") != null
        ) {
          //console.log("2");
         /*  resource.push(
            <Menu.Item key="/admin" >
              <Link to="/admin" onClick={()=>onClickMenu(setUser,setRol)}>
                <UploadOutlined />
                <span className="nac-text">Send</span>
              </Link>
            </Menu.Item>
          ); */
          resource.push(
            <Menu.Item key="/admin/output" >
              <Link to="/admin/output" style={{color:'rgb(0,104,178)'}} >
                <MenuOutlined style={{fontSize:'18px'}}/>
                <span className="nac-text">&nbsp;&nbsp;Outputs</span>
              </Link>
            </Menu.Item>
          );
        } else if (actions.find((element) => element == "GET") != null) {
          resource.push(
            <Menu.Item key="/admin" disabled>
              <Link to="/admin" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
                <UploadOutlined style={{fontSize:'18px'}} />
                <span className="nac-text">&nbsp;&nbsp;Send</span>
              </Link>
            </Menu.Item>
          );
          resource.push(
            <Menu.Item key="/admin/output">
              <Link to="/admin/output" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
                <MenuOutlined style={{fontSize:'18px'}} />
                <span className="nac-text">&nbsp;&nbsp;Outputs</span>
              </Link>
            </Menu.Item>
          );
        } else if (actions.find((element) => element == "POST") != null) {
          resource.push(
            <Menu.Item key="/admin" >
              <Link to="/admin" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
                <UploadOutlined style={{fontSize:'18px'}} />
                <span className="nac-text">&nbsp;&nbsp;Send</span>
              </Link>
            </Menu.Item>
          );
          resource.push(
            <Menu.Item key="/admin/output" disabled>
              <Link to="/admin/output" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
                <MenuOutlined style={{fontSize:'18px'}} />
                <span className="nac-text">&nbsp;&nbsp;Outputs</span>
              </Link>
            </Menu.Item>
          );
        }
      }
      actions =
        politicas.delegationEvidence.policySets[step].policies[1].target
          .actions;
      //console.log(actions);
      if (resource_type !== "GPSDEVICE") {
        devices = true;

        if (
          (actions.find((element) => element == "GET") != null &&
            actions.find((element) => element == "POST") != null) ||
          actions.find((element) => element == "*") != null
        ) {
          //console.log("GPSDEVICE2");
         /*  resource.push(
            <Menu.Item key="/admin/devices">
              <Link to="/admin/devices">
                <MobileOutlined />
                <span className="nac-text">Devices</span>
              </Link>
            </Menu.Item>
          );
          resource.push(
            <Menu.Item key="/admin/map">
              <Link to="/admin/map">
                <AimOutlined />
                <span className="nac-text">Map</span>
              </Link>
            </Menu.Item>
          ); */
        } else if (actions.find((element) => element == "GET") != null) {
          //console.log("GPSDEVICE3");
          /* resource.push(
            <Menu.Item key="/admin/devices" disabled>
              <Link to="/admin/devices">
                <MobileOutlined />
                <span className="nac-text">Devices</span>
              </Link>
            </Menu.Item>
          );
          resource.push(
            <Menu.Item key="/admin/map">
              <Link to="/admin/map">
                <AimOutlined />
                <span className="nac-text">Map</span>
              </Link>
            </Menu.Item>
          ); */
        } else if (actions.find((element) => element === "POST") != null) {
          //console.log("GPSDEVICE4");
          /* resource.push(
            <Menu.Item key="/admin/devices">
              <Link to="/admin/devices">
                <MobileOutlined />
                <span className="nac-text">Devices</span>
              </Link>
            </Menu.Item>
          );
          resource.push(
            <Menu.Item key="/admin/map" disabled>
              <Link to="/admin/map">
                <AimOutlined />
                <span className="nac-text">Map</span>
              </Link>
            </Menu.Item>
          ); */
        }
      }
    }
    if ((simulator = false)) {
      resource.push(
        <Menu.Item key="/admin">
          <Link to="/admin" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
            <UploadOutlined style={{fontSize:'18px'}} />
            <span className="nac-text">&nbsp;&nbsp;Send</span>
          </Link>
        </Menu.Item>
      );
      resource.push(
        <Menu.Item key="/admin/output">
          <Link to="/admin/output" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
            <MenuOutlined style={{fontSize:'18px'}} />
            <span className="nac-text">&nbsp;&nbsp;Outputs</span>
          </Link>
        </Menu.Item>
      );
    }
    if (devices == false) {
      /* resource.push(
        <Menu.Item key="/admin/devices">
          <Link to="/admin/devices">
            <MobileOutlined />
            <span className="nac-text">Devices</span>
          </Link>
        </Menu.Item>
      );
      resource.push(
        <Menu.Item key="/admin/map">
          <Link to="/admin/map">
            <AimOutlined />
            <span className="nac-text">Map</span>
          </Link>
        </Menu.Item>
      ); */
    }
  } catch (err) {
   //console.log(err);
  }
/*   const users={label: 'Users', icon: <UserOutlined />, key: '/admin/users'};
  const policies={label: 'Policies' ,icon:<SafetyOutlined /> , key: '/admin/mypolicies'};
  const orion={label: 'Orion', icon: <SearchOutlined />, key: "/admin/orion"};
  const items =[users,resource,policies,orion]; */
  return (
    <Sider className="admin-sider" collapsed={true}  /* collapsed={menuCollapsed} */>
      <Menu
        theme="light"
        mode="vertical"
        defaultSelectedKeys={[location.pathname]}
      >
        <Menu.SubMenu
              key="Home"
              title={
                  <span>
                      <HomeOutlined  style={{fontSize:'18px',color:'rgb(0,104,178)'}}/>
                      <span>Home</span>
                  </span>
              }
          >
              <Menu.Item key="/admin/instructions">
                <Link to="/admin/instructions" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <HomeOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Home</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Home
              </Menu.Item>
              <Menu.Item key="/admin/Historia">
                <Link to="/admin/Historia" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <HistoryOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;History</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;History
              </Menu.Item>
              <Menu.Item key="/admin/Contacto">
                <Link to="/admin/Contacto" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <ContactsOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Contact</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Contact 
              </Menu.Item>
              <Menu.Item key="/admin/DataPolicy">
                <Link to="/admin/DataPolicy" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <GlobalOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Data Policy</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Data Policy 
              </Menu.Item> 
          </Menu.SubMenu>
        <Menu.SubMenu
              key="Resources" 
              title={  
                  <span>
                      <DatabaseOutlined  style={{fontSize:'18px',color:'rgb(0,104,178)'}}/>
                      <span>Resources</span>
                  </span>
              }
          >
          <Menu.Item key="/admin/Workers">
            <Link to="/admin/Workers" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
              <UserOutlined style={{fontSize:'16px'}}/>
              {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Hubs</span> */}
            </Link>
            &nbsp;&nbsp;&nbsp;Human resources
          </Menu.Item>
          <Menu.SubMenu
              key="Physical resources" 
              title={  
                  <span>
                      <BankOutlined  style={{fontSize:'18px',color:'rgb(0,104,178)'}}/>
                      <span>Physical resources</span>
                  </span>
              }
            >
                <Menu.Item key="Hubs">
                  <Link to="/admin/hubs" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                    <BankOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Hubs</span> */}
                  </Link>
                  &nbsp;&nbsp;&nbsp;Hubs
                </Menu.Item>
                <Menu.Item key="Logistics">
                  <Link to="/admin/vehicles" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                    <CarOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Logistics</span> */}
                  </Link>
                  &nbsp;&nbsp;&nbsp;Logistics
                </Menu.Item>
                <Menu.Item key="Inventory">
                  <Link to="/admin/inventory" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                    <ScheduleOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Inventory</span> */}
                  </Link>
                  &nbsp;&nbsp;&nbsp;Inventory
                </Menu.Item>
          </Menu.SubMenu>
        </Menu.SubMenu>
        <Menu.SubMenu  
              key="Simulations"
              title={
                  <span>
                      <CalculatorOutlined  style={{fontSize:'18px',color:'rgb(0,104,178)'}}/>
                      <span>Simulations</span>
                  </span>
              }
          >
              <Menu.Item key="Data">
                <Link to="/admin/history" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <ClockCircleOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text">&nbsp;&nbsp;Data</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Data
              </Menu.Item>
              <Menu.Item key="Kmeans">
                <Link to="/admin/kmeans" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <HeatMapOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text">&nbsp;&nbsp;Kmeans</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;K-means
              </Menu.Item>
              <Menu.Item key="Inputs">
                <Link to="/admin/sendV2" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
                  <UploadOutlined style={{fontSize:'16px'}}/>
                  {/* <span className="nac-text">&nbsp;&nbsp;Inputs</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Inputs
              </Menu.Item>
              <Menu.Item key="Outputs">
                <Link to="/admin/output" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)}>
                  <MenuOutlined style={{fontSize:'16px'}} />
                  {/* <span className="nac-text">&nbsp;&nbsp;Outputs</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Outputs
              </Menu.Item>
          </Menu.SubMenu>
        <Menu.Item key="Marketplace">
          <Link to="/admin/instructions" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <ShareAltOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Marketplace (In development)</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="Financial">
          <Link to="/admin/instructions" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <EuroCircleOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Financial (In development)</span>
          </Link>
        </Menu.Item>
        {(rol==='admin')?<Menu.SubMenu
              key="admin"
              title={
                  <span>
                      <SettingOutlined  style={{fontSize:'18px',color:'rgb(0,104,178)'}}/>
                      <span>Admin</span>
                  </span>
              }
          >
              <Menu.Item key="/admin/users">  
                <Link to="/admin/users" 
                  style={{color:'rgb(0,104,178)'}} 
                  onClick={()=>onClickMenu(setUser,setRol)} >
                    <UserOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Users</span> */}
                </Link>
                &nbsp;&nbsp;&nbsp;Users
              </Menu.Item>
              <Menu.Item key="/admin/logger">
                <Link to="/admin/logger" 
                  style={{color:'rgb(0,104,178)'}} 
                  onClick={()=>onClickMenu(setUser,setRol)} >
                    <MobileOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Logger</span> */}
                 </Link>
                 &nbsp;&nbsp;&nbsp;Logger
              </Menu.Item>
              <Menu.Item key="/admin/comments">
                <Link to="/admin/comments" 
                  style={{color:'rgb(0,104,178)'}} 
                  onClick={()=>onClickMenu(setUser,setRol)} >
                    <ContactsOutlined style={{fontSize:'16px'}}/>
                    {/* <span className="nac-text" style={{color:'rgb(0,104,178)',fontSize:'16px'}}>&nbsp;&nbsp;Logger</span> */}
                 </Link>
                 &nbsp;&nbsp;&nbsp;Comments
              </Menu.Item>
          </Menu.SubMenu>:<></>}
        {/* <Menu.Item key="/admin/instructions">
          <Link to="/admin/instructions" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
          <HomeOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Home</span>
          </Link>
        </Menu.Item>
         {(rol==='admin')?<Menu.Item key="/admin/users">
          <Link to="/admin/users" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <UserOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Users</span>
          </Link>
        </Menu.Item>:<></>}
         <Menu.Item key="/admin/hubs">
          <Link to="/admin/hubs" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <BankOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Hubs</span>
          </Link>
        </Menu.Item>
         <Menu.Item key="/admin/vehicles">
          <Link to="/admin/vehicles" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <CarOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Vehicles</span>
          </Link>
        </Menu.Item>
        {(rol==='admin')?<Menu.Item key="/admin/logger">
          <Link to="/admin/logger" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <MobileOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Logger</span>
          </Link>
        </Menu.Item>:<></>}
        <Menu.Item key="/admin/history" >
          <Link to="/admin/history" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <ClockCircleOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;History</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/admin/kmeans" >
          <Link to="/admin/kmeans" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <HeatMapOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Kmeans</span>
          </Link>
        </Menu.Item>
        <Menu.Item key="/admin/sendV2" >
          <Link to="/admin/sendV2" style={{color:'rgb(0,104,178)'}} onClick={()=>onClickMenu(setUser,setRol)} >
            <UploadOutlined style={{fontSize:'18px'}}/>
            <span className="nac-text">&nbsp;&nbsp;Send</span>
          </Link>
        </Menu.Item>
        {resource} */}

      </Menu>
    </Sider>
  );
}

export default withRouter(MenuSider);
